import { internalUrls } from 'src/config/config.internalUrls';
import { config } from '../config/config';

function retrieveCookie(name) {

    const cookies: string[] = document.cookie.split(';')
        .map(cookie => cookie.trim())
        .filter(cookie => cookie.startsWith(name))
        .map(cookie => cookie.split('=')[1])
        .filter(Boolean);

    if (cookies.length >= 1) {
        return cookies.pop();
    }
}

function setAuthCookie(value) {
    const expires = '';
    const domain = internalUrls.includes(document.domain) ? '.gm.com' : window.location.hostname;
    document.cookie = `${config.authentication.authenticationCookie}=Bearer_${value}; domain=${domain}; path=/; expires=${expires}`;
}

function deleteAuthCookie() {
    const domain = internalUrls.includes(document.domain) ? '.gm.com' : window.location.hostname;
    document.cookie = `${config.authentication.authenticationCookie}=; domain=${domain}; path=/; expires=Thu, 01-Jan-70 00:00:01 GMT;`;
    document.cookie = `${config.authentication.userInfoCookie}=; domain=${domain}; path=/; expires=Thu, 01-Jan-70 00:00:01 GMT;`;
}

export const cgpCookieHelper = {
    retrieveCookie: retrieveCookie,
    setAuthCookie: setAuthCookie,
    deleteAuthCookie: deleteAuthCookie
};